import tenantHostnames from '../tenant-hostnames.json';
import { getFeatureFlagsForTenant } from './features';
import type { BrandId, TenantId, TenantRuntimeConfig } from './types';
import { DEFAULT_TENANT_ID, normalizeTenantId } from './types';

type TenantHostnameMap = Record<string, TenantId>;

const BASE_TENANT_CONFIGS: Record<TenantId, { brandId: BrandId }> = {
  'trade-proof': {
    brandId: 'trade-proof',
  },
  'warrior-trading': {
    brandId: 'warrior-trading',
  },
};

const hostnameTenantMap = Object.entries(tenantHostnames as Record<string, string>).reduce<TenantHostnameMap>((accumulator, [hostname, tenantId]) => {
  const normalizedTenantId = normalizeTenantId(tenantId);

  if (!normalizedTenantId) {
    throw new Error(`Unsupported tenant id "${tenantId}" configured for hostname "${hostname}".`);
  }

  accumulator[String(hostname || '').trim().toLowerCase()] = normalizedTenantId;
  return accumulator;
}, {} as TenantHostnameMap);

function getAllowedHostnamesForTenant(tenantId: TenantId) {
  return Object.entries(hostnameTenantMap)
    .filter(([, mappedTenantId]) => mappedTenantId === tenantId)
    .map(([hostname]) => hostname);
}

export const TENANT_CONFIGS: Record<TenantId, TenantRuntimeConfig> = {
  'trade-proof': {
    id: 'trade-proof',
    brandId: BASE_TENANT_CONFIGS['trade-proof'].brandId,
    allowedHostnames: getAllowedHostnamesForTenant('trade-proof'),
    features: getFeatureFlagsForTenant('trade-proof'),
  },
  'warrior-trading': {
    id: 'warrior-trading',
    brandId: BASE_TENANT_CONFIGS['warrior-trading'].brandId,
    allowedHostnames: getAllowedHostnamesForTenant('warrior-trading'),
    features: getFeatureFlagsForTenant('warrior-trading'),
  },
};

export function getHostnameTenantMap() {
  return { ...hostnameTenantMap };
}

export function getTenantRuntimeConfig(tenantId?: string | null): TenantRuntimeConfig {
  const normalizedTenantId = normalizeTenantId(tenantId);
  return TENANT_CONFIGS[normalizedTenantId ?? DEFAULT_TENANT_ID];
}